<template>
    <div>
        <b-container class="mt-4 mb-4" fluid>
          <b-card-group deck>
            <!-- series -->
            <b-card header-tag="header">
              <template slot="header">
                <div class="display-5">
                  <i class="fa fa-list-ol"></i> Series
                </div>
              </template>
              <template>
                  <!-- buscador de series por RUC -->
                    <b-row >
                        <b-col cols="3" class="ml-3 mb-4">
                            <b-input-group>
                                <b-input-group-append is-text >
                                <i class="fa fa-search"></i>                
                                </b-input-group-append>
                                <b-form-input type="number" @keyup.enter="validarRUC()" v-model="consultaRuc" maxlength="11" placeholder="RUC" ></b-form-input>
                            </b-input-group>
                            
                        </b-col>
                        <b-col> 
                            <b-button class="mt-1" variant="info" @click="limpiarRUC()" title="Limpiar" size="sm"><i class="fa fa-eraser"></i></b-button>
                        </b-col>
                    </b-row>
                  <!-- fin de buscador de series por RUC -->
                <b-card no-body>              
                  <b-tabs pills card vertical nav-wrapper-class="w-35" v-model="tabIndex">
                    <b-tab title="Facturas" active>
                      <template v-if="series.type1.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :per-page="series.type1.info.limit"
                              :items="series.type1.info.data"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(1,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(1,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(1)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type1.info.total"
                                v-model="series.type1.info.currentpage"
                                :per-page="series.type1.info.limit"
                                @input="getSeriesbyType(1)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Boletas de Venta">
                      <template v-if="series.type2.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type2.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(2,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(2,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(2)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type2.info.total"
                                v-model="series.type2.info.currentpage"
                                :per-page="series.type2.info.limit"
                                @input="getSeriesbyType(2)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Notas de Crédito - Facturas">
                      <template v-if="series.type3.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type3.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(3,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(3,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(3)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type3.info.total"
                                v-model="series.type3.info.currentpage"
                                :per-page="series.type3.info.limit"
                                @input="getSeriesbyType(3)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Notas de Crédito - Boletas">
                      <template v-if="series.type4.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type4.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(4,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(4,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(4)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type4.info.total"
                                v-model="series.type4.info.currentpage"
                                :per-page="series.type4.info.limit"
                                @input="getSeriesbyType(4)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Notas de Débito - Facturas">
                      <template v-if="series.type5.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type5.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(5,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(5,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(5)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type5.info.total"
                                v-model="series.type5.info.currentpage"
                                :per-page="series.type5.info.limit"
                                @input="getSeriesbyType(5)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Notas de Débito - Boletas">
                      <template v-if="series.type6.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type6.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(6,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(6,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(6)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type6.info.total"
                                v-model="series.type6.info.currentpage"
                                :per-page="series.type6.info.limit"
                                @input="getSeriesbyType(6)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Guías de Remisión">
                      <template v-if="series.type7.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type7.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(7,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(7,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(7)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type7.info.total"
                                v-model="series.type7.info.currentpage"
                                :per-page="series.type7.info.limit"
                                @input="getSeriesbyType(7)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Proformas">
                      <template v-if="series.type8.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type8.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(8,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(8,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(8)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type8.info.total"
                                v-model="series.type8.info.currentpage"
                                :per-page="series.type8.info.limit"
                                @input="getSeriesbyType(8)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Orden de Compra">
                      <template v-if="series.type9.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type9.info.data"
                              
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(9,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(9,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(9)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type8.info.total"
                                v-model="series.type8.info.currentpage"
                                :per-page="series.type8.info.limit"
                                @input="getSeriesbyType(9)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Guía de Control">
                      <template v-if="series.type10.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type10.info.data"
                              :per-page="series.type1.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(10,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(10,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(10)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type10.info.total"
                                v-model="series.type10.info.currentpage"
                                :per-page="series.type10.info.limit"
                                @input="getSeriesbyType(10)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>               
                    <b-tab title="Orden de Pago">
                      <template v-if="series.type11.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type11.info.data"
                              :per-page="series.type11.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(11,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(11,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(11)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type11.info.total"
                                v-model="series.type11.info.currentpage"
                                :per-page="series.type11.info.limit"
                                @input="getSeriesbyType(11)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>
                    <b-tab title="Nota de Venta">
                      <template v-if="series.type12.cargar">
                        <div class="text-center">
                          <h5>
                            <i class="fa fa-spin fa-spinner"></i> Cargando Datos
                          </h5>
                        </div>
                      </template>
                      <template v-else>
                        <b-row>
                          <b-col>
                            <b-table
                              small
                              outlined
                              striped
                              hover
                              :items="series.type12.info.data"
                              :per-page="series.type12.info.limit"
                              :fields="seriesfields"
                            >
                              <template slot="index" slot-scope="data">{{ data.index }}</template>
                              <template
                                slot="ultimoserie"
                                slot-scope="data"
                              >{{ data.item.utimoSerie }}</template>
                              <template slot="acciones" slot-scope="data">
                                <div class="text-center">
                                  <b-button-group>
                                    <template v-if="data.item.count<1">
                                      <b-button
                                        variant="secondary"
                                        size="sm"
                                        @click="openModalSerieUpdate(12,data.item)"
                                      >
                                        <i class="fa fa-edit"></i>
                                      </b-button>
                                      <b-button
                                        variant="danger"
                                        size="sm"
                                        @click="openModalSerieDelete(12,data.item)"
                                      >
                                        <i class="fa fa-trash"></i>
                                      </b-button>
                                    </template>
                                    <template v-else>
                                      <b-button variant="secondary" disabled>
                                        <i class="fa fa-lock"></i>
                                      </b-button>
                                    </template>
                                  </b-button-group>
                                </div>
                              </template>
                            </b-table>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col>
                            <b-button variant="primary" @click="openModalSerie(12)" size="sm">
                              <i class="fa fa-plus"></i> Agregar
                            </b-button>
                          </b-col>
                          <b-col>
                            <div class="float-right">
                              <b-pagination
                                size="sm"
                                :total-rows="series.type12.info.total"
                                v-model="series.type12.info.currentpage"
                                :per-page="series.type12.info.limit"
                                @input="getSeriesbyType(11)"
                              ></b-pagination>
                            </div>
                          </b-col>
                        </b-row>
                      </template>
                    </b-tab>

                    <b-tab title="Percepciones" disabled>Tab Contents</b-tab>
                    <b-tab title="Retenciones" disabled>Tab Contents 11</b-tab>
                  </b-tabs>
                </b-card>
              </template>
            </b-card>
            <b-modal v-model="modalserie" title="Agregar Serie">
              <b-row>
                <b-col>
                  <b-form-group label="COMPROBANTE">
                    <b-input-group>
                      <b-form-select
                        v-model="typecomprobant"
                        :options="comprobants"
                        :value-field="'value'"
                        :text-field="'name'"
                        readonly
                      />
                      <b-input-group-append>
                        <b-btn variant="secondary">
                          <i class="fa fa-file-text-o"></i>
                        </b-btn>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Serie">
                    <b-input-group :prepend="getPrefixDoc(typecomprobant)">
                      <b-form-input type="text" v-model="serie" maxlength="3"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Inicial">
                    <b-input-group prepend="#">
                      <b-form-input type="number" v-model="startin" maxlength="8"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <template slot="modal-footer">
                <div>
                  <template v-if="cargarconfigserie">
                    <b-button variant="secondary" class="disabled">
                      <i class="fa fa-spin fa-spinner"></i> Grabando
                    </b-button>
                  </template>
                  <template v-else>
                    <b-button variant="secondary mr-1" @click="modalserie=false">
                      <i class="fa fa-times"></i> Cancelar
                    </b-button>
                    <b-button variant="primary" @click="storeSerie()">
                      <i class="fa fa-save"></i> Grabar
                    </b-button>
                  </template>
                </div>
              </template>
            </b-modal>
            <b-modal v-model="modalserieupdate" title="Editar Serie">
              <b-row>
                <b-col>
                  <b-form-group label="COMPROBANTE">
                    <b-input-group>
                      <b-form-select
                        v-model="typecomprobant2"
                        :options="comprobants"
                        :value-field="'value'"
                        :text-field="'name'"
                        disabled
                      />
                      <b-input-group-append>
                        <b-btn variant="secondary">
                          <i class="fa fa-file-text-o"></i>
                        </b-btn>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-form-group label="Serie">
                    <b-input-group :prepend="getPrefixDoc(typecomprobant2)">
                      <b-form-input type="text" v-model="serie2" maxlength="3"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col>
                  <b-form-group label="Inicial">
                    <b-input-group prepend="#">
                      <b-form-input type="number" v-model="startin2"></b-form-input>
                    </b-input-group>
                  </b-form-group>
                </b-col>
              </b-row>
              <template slot="modal-footer">
                <div>
                  <template v-if="cargarconfigserie2">
                    <b-button variant="secondary" class="disabled">
                      <i class="fa fa-spin fa-spinner"></i> Grabando
                    </b-button>
                  </template>
                  <template v-else>
                    <b-button variant="secondary mr-1" @click="modalserieupdate=false">
                      <i class="fa fa-times"></i> Cancelar
                    </b-button>
                    <b-button variant="primary" @click="updateSerie()">
                      <i class="fa fa-save"></i> Grabar
                    </b-button>
                  </template>
                </div>
              </template>
            </b-modal>
            <b-modal centered v-model="modalseriedelete" title="Eliminar Serie">
              <div class="text-center">
                <h5 class="my-auto">
                  Desea Eliminar la Serie
                  <b>{{' '+ serie3 +' '}}</b> ?
                </h5>
              </div>
              <template slot="modal-footer">
                <div>
                  <template v-if="cargarconfigserie3">
                    <b-button variant="secondary" class="disabled">
                      <i class="fa fa-spin fa-spinner"></i> Eliminando
                    </b-button>
                  </template>
                  <template v-else>
                    <b-button variant="secondary mr-1" @click="modalseriedelete=false">
                      <i class="fa fa-times"></i> Cancelar
                    </b-button>
                    <b-button variant="danger" @click="deleteSerie()">
                      <i class="fa fa-trash"></i> Eliminar
                    </b-button>
                  </template>
                </div>
              </template>
            </b-modal>
            <!-- fin series -->
          </b-card-group>
        </b-container>
        <vue-snotify></vue-snotify>
    </div>
</template>
<script>
import axios from "axios";
import { TipoMoneda } from "@/shared/utils";
import Tag from "@/components/userpanel/tag";
import { Departamentos } from '@/shared/utils';
export default {
    name:"seriesSoporteData",
    components: { Tag },
    data() {
        return {
            cargando:true,
            checked: false,
            ancho: "",
            alto: "",
            cargarimpresion: false,
            responseinfoclient: "",
            telefono: "",
            nombreComercial: "",
            nombreSucursal: "",
            direccion: "",
            paginaWeb: "",
            correo: "",
            textoPersonalizado1: "",
            textoPersonalizado2: "",
            emitiendobank: true,
            actualizandobank: true,
            changeNumeroCuenta: 0,
            changeCci: 0,
            actualizar: false,
            validbancoguardar: true,
            otrobanco: "",
            addbank: false,
            isBusy: false,
            listaBancos: [],
            buscandoCtaDetraccion: false,
            detraccionExiste: false,
            botonesDetraccionExiste: false,
            previoModificar: false,
            vistaModificar: false,
            modificando: false,
            crearCuentaDetraccion: false,
            agregandoCuentaDet: false,
            razon_social: "",
            domicilio_fiscal: "",
            rucCliente: "",
            updateAccount: false,
            modifyAccount: false,
            modifyAccountDatos: false,
            updateClienteDatos: false,
            cuentaDetracionAdmin: "",
            addDetraccion: true,
            cuentaDetraccion: "",
            tabIndex: [0, 0],
            tabs: ["Usuario", "Contraseña", "Gestion"],
            stores: [],
            banco_fields: [
                { key: "banco", label: "Banco", sortable: true },
                { key: "tipoCuenta", label: "Tipo Cta.", sortable: true },
                { key: "moneda", label: "Moneda", sortable: true },
                { key: "numeroCuenta", label: "Cuenta", sortable: true },
                { key: "cci", label: "CCI", sortable: true },
                { key: "acciones", label: "Acciones", sortable: true }
            ],
            storeitems: [
                { key: "index", label: "#", sortable: true },
                { key: "nombreEstablecimiento", label: "Nombre", sortable: true },
                { key: "codigoEstablecimiento", label: "Código", sortable: true },
                { key: "registro", label: "Registro", sortable: true },
                { key: "ubigeo", label: "Ubigeo", sortable: true },
                { key: "direccion", label: "Direccion", sortable: true },
                { key: "acciones", label: "Acciones", sortable: true }
            ],
            banco: {
                id: 0,
                descripcion: "BCP"
            },
            Bancos: [
                { id: 0, descripcion: "BCP" },
                { id: 1, descripcion: "BBVA" },
                { id: 2, descripcion: "Interbank" },
                { id: 3, descripcion: "Scotiabank Perú" },
                { id: 4, descripcion: "PICHINCHA" },
                { id: 5, descripcion: "MiBanco" },
                { id: 6, descripcion: "BanBif" },
                { id: 7, descripcion: "Banco de Comercio" },
                { id: 8, descripcion: "Banco Pichincha" },
                { id: 9, descripcion: "Citibank Perú" },
                { id: 10, descripcion: "Banco GNB Perú" },
                { id: 11, descripcion: "Banco Falabella" },
                { id: 12, descripcion: "Banco de la Nación" },
                { id: 13, descripcion: "INGRESE NUEVO BANCO" }
            ],
            Cuentas: [
                { id: 0, descripcion: "CTA. CTE." },
                { id: 1, descripcion: "CTA. AHORROS" },
                { id: 2, descripcion: "CTA. MAESTRA" },
                { id: 3, descripcion: "T. CRÉDITO" },
                { id: 4, descripcion: "CTA. DETRACCIONES" },
                { id: 5, descripcion: "INGRESE OTRA CUENTA" }
            ],
            tipodemoneda: {
                id: "1",
                codigo: "PEN",
                descripcion: "SOLES",
                simbolo: "S/."
            },
            idBanco: "",
            tipoMoneda: TipoMoneda,
            numerocuenta: "",
            cci: "",
            cuenta: { id: 0, descripcion: "CTA. CTE." },
            otracuenta: "",
            loadingstores: false,
            namestore: "",
            codestore: "",
            loadingstores2: false,
            editidstore: "",
            editnamestore: "",
            editcodestore: "",
            loadingstores3: false,
            users: [],
            useritems: [
                { key: "index", label: "#", sortable: true },
                { key: "username", label: "Nombre", sortable: true },
                { key: "registro", label: "Registro", sortable: true },
                { key: "rol", label: "Rol", sortable: true },
                { key: "acciones", label: "Acciones", sortable: true }
            ],
            roleusers: [
                { value: 1, text: "Administrador" },
                { value: 2, text: "Operador" },
                { value: 3, text: "Consultor" }
            ],
            roleusers2: [
                { value: 1, text: "Administrador" },
                { value: 2, text: "Operador" },
                { value: 3, text: "Consultor" },
                { value: 4, text: "Asistente Contable"}
            ],
            loadingseries: false,
            userseriesf: [],
            userseriesb: [],
            userseriesncf: [],
            userseriesncb: [],
            userseriesndf: [],
            userseriesndb: [],
            userseriesgr: [],
            seriesfacturas: [],
            seriesboletas: [],
            seriesnotascf: [],
            seriesnotascb: [],
            seriesnotasdf: [],
            seriesnotasdb: [],
            seriesgr: [],
            seriesgc: [],
            seriesp: [],
            seriesoc: [],
            seriesop: [],
            seriesnv: [],
            seriesfacturasc: [],
            seriesboletasc: [],
            seriesnotascfc: [],
            seriesnotascbc: [],
            seriesnotasdfc: [],
            seriesnotasdbc: [],
            seriesgrc: [],
            show: true,
            personalizar: {
                claveNueva1: "",
                claveNueva2: ""
            },
            modalstore: false,
            modalupdate: false,
            modaluser: false,
            modaluseredit: false,
            user: {
                username: "",
                rol: "",
                idEmisor: "",
                cuenta: {
                razonSocial: ""
                },
                perfil: {}
            },
            tabs: 0,
            passvalid: false,
            loading: false,
            change: false,
            loadingusers: false,
            loadinguser: false,
            loadinguser2: false,
            // series: [],
            soptions: [
                { value: 5, text: 5 },
                { value: 15, text: 15 },
                { value: 25, text: 25 },
                { value: 50, text: 50 },
                { value: 100, text: 100 }
            ],
            sperPage: 15,
            scurrentPage: 1,
            srows: 0,
            uoptions: [
                { value: 5, text: 5 },
                { value: 15, text: 15 },
                { value: 25, text: 25 },
                { value: 50, text: 50 },
                { value: 100, text: 100 }
            ],
            uperPage: 15,
            ucurrentPage: 1,
            urows: 0,
            newuser: {
                username: "",
                perfil: {
                rol: "",
                idEstablecimiento: 0,
                appUsuario: "",
                apmUsuario: "",
                nomUsuario: "",
                rolUsuario: "",
                seriesemUsuario: {
                    "1": [],
                    "2": [],
                    "3": [],
                    "4": [],
                    "5": [],
                    "6": [],
                    "7": [],
                    "8": [],
                    "9": [],
                    "10": [],
                    "11": [],
                    "12": []
                }
                }
            },
            edituser: {
                username: "",
                perfil: {
                rol: "",
                idEstablecimiento: 0,
                appUsuario: "",
                apmUsuario: "",
                nomUsuario: "",
                rolUsuario: "",
                seriesemUsuario: {
                    "1": [],
                    "2": [],
                    "3": [],
                    "4": [],
                    "5": [],
                    "6": [],
                    "7": [],
                    "8": [],
                    "9": [],
                    "10": [],
                    "11": [],
                    "12": []
                },
                seriesconUsuario: {
                    "1": [],
                    "2": [],
                    "3": [],
                    "4": [],
                    "5": [],
                    "6": [],
                    "7": [],
                    "8": [],
                    "9": [],
                    "10": [],
                    "11": [],
                    "12": []
                }
                }
            },
            //sett
            totalRows: null,
            cargarconfigdoc: false,
            cargarconfigcode: false,
            cargarconfigacc: false,
            cargarconfigadd: false,
            cargarconfigserie: false,
            cargarconfigdoc2: false,
            cargarconfigcode2: false,
            cargarconfigacc2: false,
            cargarconfigadd2: false,
            cargarconfigserie2: false,
            cargarconfigserie3: false,
            sizes: [
                { value: "A3", text: "A3" },
                { value: "A4", text: "A4" },
                { value: "A5", text: "A5" },
                { value: "Letter", text: "CARTA" },
                { value: "Legal", text: "OFICIO" },
                { value: "Tabloid", text: "TABLOIDE" },
                { value: "Custom", text: "PERSONALIZADO" }
            ],
            size: "Custom",
            height: 80,
            witdh: 240,
            orientations: [
                { value: "portrait", text: "VERTICAL" },
                { value: "landscape", text: "HORIZONTAL" }
            ],
            orientation: "portrait",
            typecode: "QR",
            user: {
                username: "",
                rol: "",
                idEmisor: "",
                cuenta: {
                razonSocial: "",
                direccion: {}
                }
            },
            logo: "",
            changelogo: false,
            savinglogo: false,
            urlimg: null,
            modalserie: false,
            modalserieupdate: false,
            modalseriedelete: false,
            comprobants: [
                { value: 1, name: "Factura" },
                { value: 2, name: "Boleta de Venta" },
                { value: 3, name: "Nota de Crédito - Factura" },
                { value: 4, name: "Nota de Crédito - Boleta" },
                { value: 5, name: "Nota de Débito - Factura" },
                { value: 6, name: "Nota de Débito - Boleta" },
                { value: 7, name: "Guía de Remisión" },
                { value: 10, name: "Guía de Control" },
                { value: 8, name: "Proforma" },
                { value: 9, name: "Orden de Compra" },
                { value: 11, name: "Orden de Pago" },
                { value: 12, name: "Nota de Venta" }
            ],
            tabIndex: 0,
            typecomprobant: 0,
            serie: "",
            startin: 0,
            typecomprobant2: 0,
            typecomprobant3: 0,
            serie2: "",
            serie3: "",
            startin2: 0,
            idserie: "",
            series: {
                type1: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type2: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type3: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type4: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type5: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type6: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type7: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type8: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type9: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },
                cargar: false
                },
                type10: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },

                cargar: false
                },
                type11: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },

                cargar: false
                },
                type12: {
                info: {
                    data: [],
                    currentpage: 1,
                    from: 0,
                    to: 0,
                    limit: 10,
                    total: 0
                },

                cargar: false
                }
            },
            seriesfields: [
                { key: "index", label: "#", sortable: true },
                { key: "nombreSerie", label: "Serie", sortable: true },
                { key: "ultimoSerie", label: "Útimo", sortable: true },
                { key: "acciones", label: "Acciones", sortable: true }
            ],
            seriesall: [],
            currentPage: 1,
            tipo: 1,
            validarServicio:[],
            cod:'wenet',
            servicio: false,
            modalServicio:false,
            listDepartamento: Departamentos,
            departamentoUbigeo:'',
            provOrigen:false,
            provOrigenCargando:false,
            listProvinceOrigen: [],
            provinciaUbigeo:'',
            distOrigen:false,
            distOrigenCargando:false,
            distritoUbigeo:'',
            listDistrictOrigen: [],
            ubigeoPartida:'',
            direcUbigeo:'',
            autorizar:'',
            listaAsociados:[],
            listaAsociados_fields:[
                {key:"idContador", label:"RUC Contador"},
                {key:"fechaAfiliacion", label:"Fecha Afiliado"},
                // {key:"fechaTermino", label:"Fecha Fin"},
                {key:"estado", label:"Estado"}
            ],
            listaAsociadosTerminados:[],
            listaAsociadosTerminados_fields:[
                {key:"idContador", label:"RUC Contador"},
                {key:"fechaAfiliacion", label:"Fecha Afiliado"},
                {key:"fechaTermino", label:"Fecha Fin"},
                {key:"estado", label:"Estado"}
            ],
            servicioConta:false,
            listadoInvertido:[],
            listaUsuarioInfo:[],
            selectedInfoUsuario:null,
            idmovil:'',
            verActualizar:true,
            visible:false,
            longitud:false,
            mayus:false,
            minus:false,
            number:false,
            consultaRuc:'',
        }
    },
    watch:{
        tabIndex: function() {
            this.getSeriesbyType(this.tabIndex + 1);
        },  
    },
    mounted(){
        // this.getSeriesbyType(1)
    },
    methods: {
        getPrefixDoc: function(value) {
            if (value == 1 || value == 3 || value == 5) {
                return "F";
            }
            if (value == 2 || value == 4 || value == 6) {
                return "B";
            }
            if (value == 7) {
                return "T";
            }
            if (value == 8) {
                return "P";
            }
            if (value == 9) {
                return "OC";
            }
            if (value == 10) {
                return "GC";
            }
            if (value == 11) {
                return "OP";
            }
            if (value == 12) {
                return "NV";
            }
        },
        getSeriesbyType: function(type) {
        var table = {
            info: {
            data: [],
            currentpage: 1,
            from: 0,
            to: 0,
            limit: 10,
            total: 0
            },
            cargar: false
        };
        switch (type) {
            case 1:
            table = this.series.type1;
            break;
            case 2:
            table = this.series.type2;
            break;
            case 3:
            table = this.series.type3;
            break;
            case 4:
            table = this.series.type4;
            break;
            case 5:
            table = this.series.type5;
            break;
            case 6:
            table = this.series.type6;
            break;
            case 7:
            table = this.series.type7; //guia remision
            break;
            case 8:
            table = this.series.type8; //proforma
            break;
            case 9:
            table = this.series.type9; // orden compra
            break;
            case 10:
            table = this.series.type10; // guia de control 
            break;
            case 11:
            table = this.series.type11;// orden pago 
            break;
            case 12:
            table = this.series.type12; // nota de venta
            break;
        }
        table.cargar = true;

        axios
            .post(process.env.VUE_APP_API_URL + "series/soporte/listar/tipo", {
            token: this.$store.getters.userToken,
            tipo: type,
            ruc: this.consultaRuc,
            page: table.info.currentpage
            })
            .then(
            response => (
                (table.info.data = response.data.response.data),
                // (table.info.totalRows = table.info.data.length),
                (table.info.currentpage = response.data.response.current_page),
                (table.info.from = response.data.response.from),
                (table.info.to = response.data.response.to),
                (table.info.limit = response.data.response.per_page),
                (table.info.total = response.data.response.total),
                (table.cargar = false)
            )
            )
            .catch(function(error) {
            table.cargar = false;
            });
        },
        openModalSerie: function(doc) {
            this.modalserie = true;
            this.typecomprobant = doc;
        },
        storeSerie: function() {
        this.cargarconfigserie = true;
        let prefix = this.getPrefixDoc(this.typecomprobant);
        axios
            .post(process.env.VUE_APP_API_URL + "series/soporte/registrar", {
            token: this.$store.getters.userToken,
            nombre: prefix + this.serie,
            ultimo: this.startin,
            tipo: this.typecomprobant,
            ruc: this.consultaRuc
            })
            .then(
            response => (
                this.$snotify.success(response.data.msg, "Éxito"),
                (this.cargarconfigserie = false),
                this.getSeriesbyType(this.typecomprobant),
                (this.tabIndex = this.typecomprobant - 1),
                (this.modalserie = false),
                (this.serie = "")
            )
            )
            .catch(
            error => (
                this.$snotify.error(error.response.data.msg, "Error"),
                (this.cargarconfigserie = false)
            )
            );
        },
        openModalSerieDelete: function(doc, data) {
            this.modalseriedelete = true;
            this.typecomprobant3 = doc;
            this.serie3 = data.nombreSerie;
            this.idserie = data.idSerie;
        },
        deleteSerie: function() {
        this.cargarconfigserie3 = true;
        axios
            .post(process.env.VUE_APP_API_URL + "series/soporte/eliminar/" + this.idserie, {
                token: this.$store.getters.userToken,
                ruc: this.consultaRuc
            })
            .then(
            response => (
                this.$snotify.success(response.data.msg, "Éxito"),
                (this.cargarconfigserie3 = false),
                this.getSeriesbyType(this.typecomprobant3),
                // this.tabIndex = this.typecomprobant-1,
                (this.modalseriedelete = false)
            )
            )
            .catch(
            error => (
                this.$snotify.error(error.response.data.msg, "Error"),
                (this.cargarconfigserie3 = false)
            )
            );
        },
        validarRUC(){
            if(this.consultaRuc.length === 11){
                this.getSeriesbyType(1);
            }else{
                this.$snotify.warning("El RUC debe contener 11 dígitos", "Cuidado")
            }
        },
        limpiarRUC(){
            this.consultaRuc = ""
        },
        openModalSerieUpdate: function(doc, data) {
            this.modalserieupdate = true;
            this.typecomprobant2 = doc;
            this.serie2 = data.nombreSerie.substring(1);
            this.startin2 = data.ultimoSerie;
            this.idserie = data.idSerie;
        },
        updateSerie: function() {
        this.cargarconfigserie2 = true;
        let prefix = this.getPrefixDoc(this.typecomprobant2);
        axios
            .post(
            process.env.VUE_APP_API_URL + "series/soporte/actualizar/" + this.idserie,
            {
                token: this.$store.getters.userToken,
                nombre: prefix + this.serie2,
                ultimo: this.startin2,
                tipo: this.typecomprobant2,
                ruc:this.consultaRuc
            }
            )
            .then(
            response => (
                this.$snotify.success(response.data.msg, "Éxito"),
                (this.cargarconfigserie2 = false),
                this.getSeriesbyType(this.typecomprobant2),
                (this.tabIndex = this.typecomprobant - 1),
                (this.modalserieupdate = false)
            )
            )
            .catch(
            error => (
                this.$snotify.error(error.response.data.msg, "Error"),
                (this.cargarconfigserie2 = false)
            )
            );
        },
    },
}
</script>
<style scoped>

</style>